export const watchBack = (onBack: () => void): (() => void) => {
  if (!('CloseWatcher' in window)) {
    return () => {};
  }

  let watcher: CloseWatcher;

  const startWatching = () => {
    watcher = new CloseWatcher();
    watcher.onclose = () => {
      startWatching();
      onBack();
    };
  };

  startWatching();

  return () => {
    watcher.onclose = null;
    watcher.destroy();
  };
};

export const ignoreBackUntilFirstInteraction = (): (() => void) => {
  const stopWatching = watchBack(() => {});

  window.addEventListener('pointerup', stopWatching, { once: true });
  window.addEventListener('keydown', stopWatching, { once: true });

  return () => {
    window.removeEventListener('pointerup', stopWatching);
    window.removeEventListener('keydown', stopWatching);
    stopWatching();
  };
};
